export default __webpack_public_path__ + "static/media/contact_hana_zahorovska.1ba4c8f5.jpg";